<template>
  <div>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3 d-none d-md-flex"></div>
        <div class="col-md-16 px-3 py-3 mb-5">
          <div class="card">
            <div class="card-body py-3 d-flex justify-content-between">
              <div
                class="d-flex align-items-center"
                style="gap: 10px; height: 70px"
              >
                <svg
                  v-if="dataPentest.type == 'whitebox'"
                  width="50"
                  height="50"
                >
                  <image
                    xlink:href="../../../assets/icons/whitebox.png"
                    width="50"
                    height="50"
                  />
                </svg>
                <svg v-else width="50" height="50">
                  <image
                    xlink:href="../../../assets/icons/blackbox.png"
                    width="50"
                    height="50"
                  />
                </svg>
                <div>
                  <p
                    class="m-0"
                    style="font-size: 24px; font-weight: 400"
                    v-if="dataPentest.type === 'whitebox'"
                  >
                    {{ $ml.get("whitebox") }}
                  </p>

                  <p
                    class="m-0"
                    style="font-size: 24px; font-weight: 400"
                    v-else
                  >
                    {{ $ml.get("blackbox") }}
                  </p>

                  <div>
                    <a
                      class="badge badge-warning text-white"
                      v-if="dataPentest?.status == 'pending'"
                      v-text="$ml.get('pending')"
                      >Pendente</a
                    >
                    <a
                      class="badge badge-warning text-white"
                      v-if="dataPentest?.status == 'review'"
                      v-text="$ml.get('under_review')"
                      >Em revisão</a
                    >
                    <a
                      class="badge badge-success text-white"
                      v-show="dataPentest?.status == 'in_progress'"
                      v-text="$ml.get('inProgress')"
                      >Em progresso</a
                    >
                    <a
                      class="badge badge-success text-white"
                      v-show="dataPentest?.status == 'done'"
                      v-text="$ml.get('finished')"
                      >Finalizado</a
                    >
                    <a
                      class="badge badge-success text-white"
                      v-show="dataPentest?.status == 'approved'"
                      v-text="$ml.get('approved')"
                      >Aprovado</a
                    >
                    <a
                      class="badge badge-danger text-white"
                      v-show="dataPentest?.status == 'canceled'"
                      v-text="$ml.get('situationCancel')"
                      >Cancelado</a
                    >
                  </div>
                </div>
              </div>
              <div
                class="d-flex flex-column align-items-end justify-content-end"
              >
                <div class="form-group mt-3">
                  <div
                    v-if="dataPentest.status != 'canceled'"
                    class="d-flex"
                    style="gap: 10px"
                  >
                    <a
                      v-if="dataPentest.status === 'done'"
                      :href="dataPentest.file"
                      target="_blank"
                      class="btn btn-export"
                    >
                      <!-- <Spinner v-show="loadingBtn" class="px-5" /> -->
                      <font class="mr-1">Download</font>
                      <img
                        class="mb-1"
                        src="../../../assets/icons/download-white.svg"
                        width="15"
                        height="15"
                      />
                    </a>
                    <button
                      v-show="dataPentest.status === 'pending'"
                      class="btn"
                      v-text="$ml.get('edit')"
                      @click="
                        $router.push({
                          name: 'pentestEdit',
                          query: { id: idPentest },
                        })
                      "
                    >
                      Editar
                    </button>
                    <button
                      v-show="dataPentest.status === 'pending'"
                      class="btn btn-outline-extra"
                      v-text="$ml.get('delete')"
                      @click="deletePentest(idPentest)"
                    >
                      Excluir
                    </button>
                  </div>
                </div>
                <h6
                  v-if="dataPentest.initialDate"
                  class="m-0 mb-1"
                  style="font-weight: 400"
                >
                  {{ $ml.get("startDate") }}:
                  {{ $utils.formatDataShort(dataPentest?.initialDate) }}
                </h6>
                <h6
                  v-if="dataPentest.finalDate"
                  class="m-0"
                  style="font-weight: 400"
                >
                  {{ $ml.get("endDate") }}:
                  {{ $utils.formatDataShort(dataPentest?.finalDate) }}
                </h6>
              </div>
            </div>
          </div>
          <div
            class="alert alert-warning mb-0 mt-2"
            v-show="dataPentest.status === 'review' && dataPentest.message"
          >
            <p v-html="$utils.convertMarkedOld(dataPentest.message)"></p>
          </div>
          <div class="col d-column">
            <div
              v-if="
                !['owner', 'administrator'].includes(
                  this.$store.getters['getUser'].role,
                )
              "
              class="card mb-3"
            >
              <div class="card-header">Opss...</div>
              <div class="card-body">
                <div class="d-flex justify-content-center">
                  <h2
                    class="size-1_4 p-3"
                    v-text="$ml.get('viewersCannotCreatePentest')"
                  >
                    Usuários do tipo visualizador não tem permissão para criar
                    programas!
                  </h2>
                </div>
              </div>
            </div>

            <font v-else>
              <div class="mb-3">
                <div class="d-column flex-row">
                  <div
                    class="h-form h-profile-lg d-flex flex-column pb-3 align-items-center no"
                  >
                    <!-- Configurações Tipo de Pentest -->
                    <config
                      number="1"
                      :view="true"
                      :dataPentest="dataPentest"
                    />

                    <!-- Escopo -->
                    <Scope number="2" :view="true" :dataPentest="dataPentest" />
                    <!--Sobre-->
                    <about number="3" :view="true" :dataPentest="dataPentest" />
                  </div>
                </div>
              </div>
            </font>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import $ from "jquery";
import Swal from "sweetalert2";
import ProgramService from "../../../services/program.service";

import About from "../../../components/company/program/about_pentest.vue";
import Config from "../../../components/company/program/config_pentest.vue";
import Scope from "../../../components/company/program/scope_pentest.vue";
import pentestService from "../../../services/pentest.service";
export default {
  name: "Pentest",

  components: {
    Config,
    About,
    Scope,
  },

  data() {
    return {
      idPentest: "",
      dataPentest: {},

      initialDate: null,
      finalDate: null,
      type: "whitebox",
      retest: false,

      aboutCriticalApplication: false,
      aboutHandleLargeVolumes: false,
      aboutFinancialTransactions: false,

      accessCredentials: false,
      sourceCode: false,

      listScope: [],
      listProfile: [],

      location: "remote",

      summary: "",

      tokenRecaptcha: "",

      errorConfig: {
        initialDate: false,
        finalDate: false,
      },
      error_scope: false,
      summaryError: false,
    };
  },

  mounted() {
    this.idPentest = this.$route.query.id;
    this.getPentestById(this.idPentest);
  },
  methods: {
    deletePentest(id) {
      var self = this;

      Swal.fire({
        heightAuto: false,
        text: self.$ml.get("areYouSureYouWantToDeleteThisPentest"),
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#730ba9",
        customClass: {
          cancelButton: "btn-outline-extra",
        },
        confirmButtonText: self.$ml.get("remove"),
        cancelButtonText: self.$ml.get("cancel"),
      }).then((result) => {
        if (result.value) {
          pentestService.deletePentest(id).then(
            () => {
              Swal.fire({
                icon: "success",
                title: self.$ml.get("swalDeletedPentest"),
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
              this.getPentestById(this.idPentest);
            },
            (error) => {
              console.log(error);
              Swal.fire({
                icon: "warning",
                title: self.$ml.get("unableToCompleteThisRequest"),
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
            },
          );
        }
      });
    },
    async getPentestById(id) {
      try {
        const { data } = await pentestService.getPentestByID(id);
        this.dataPentest = data;
      } catch (error) {
        console.log(error);
      }
    },

    getInitialDate(data) {
      this.initialDate = data ?? null;
    },
    getFinalDate(data) {
      this.finalDate = data ?? null;
    },
    getTypePentest(data) {
      this.type = data;
    },
    getRetest(data) {
      this.retest = data;
    },
    getListProfile(data) {
      this.listProfile = data ?? [];
    },
    getAccessCredentials(data) {
      this.accessCredentials = data;
    },
    getSourceCode(data) {
      this.sourceCode = data;
    },
    getLocation(data) {
      this.location = data;
    },
    getSummaryPentest(data) {
      this.summary = data ?? "";
    },
    getAboutCriticalApplication(data) {
      this.aboutCriticalApplication = data;
    },
    getAboutHandleLargeVolumes(data) {
      this.aboutHandleLargeVolumes = data;
    },
    getAboutFinancialTransactions(data) {
      this.aboutFinancialTransactions = data;
    },
    getListScop(data) {
      this.listScope = data ?? [];
    },
    setRecaptchToken(token) {
      this.tokenRecaptcha = token;
    },

    validateForm() {
      this.errorConfig.initialDate = false;
      this.errorConfig.finalDate = false;
      this.error_scope = false;
      this.summaryError = false;

      if (!this.initialDate) {
        this.errorConfig.initialDate = true;
      }

      if (!this.finalDate) {
        this.errorConfig.finalDate = true;
      }

      if (!this.listScope.length) {
        this.error_scope = true;
      }
      if (!this.summary) {
        this.summaryError = true;
      }

      if (!this.initialDate || !this.finalDate || !this.listScope.length) {
        this.$refs.recaptcha.resetRecaptcha();
        $("html, body").animate({ scrollTop: 0 }, "5000");

        return Swal.fire({
          icon: "warning",
          title: this.$ml.get("fillInAllFieldHighlightedInRed"),
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      }

      this.savePentest();
    },

    async savePentest() {
      try {
        const formData = new FormData();

        formData.append("initialDate", this.initialDate);
        formData.append("finalDate", this.finalDate);
        formData.append("type", this.type);
        formData.append("applicationLocation", this.location);
        formData.append("reTest", this.retest);
        formData.append("profiles", JSON.stringify(this.listProfile));
        formData.append("scope", JSON.stringify(this.listScope));
        formData.append("tokenRecaptcha", this.tokenRecaptcha);
        formData.append("aboutDescription", this.summary);
        formData.append(
          "aboutCriticalApplication",
          this.aboutCriticalApplication,
        );
        formData.append(
          "aboutHandleLargeVolumes",
          this.aboutHandleLargeVolumes,
        );
        formData.append(
          "aboutFinancialTransactions",
          this.aboutFinancialTransactions,
        );

        if (this.type === "whitebox") {
          formData.append("accessCredentials", this.accessCredentials);
          formData.append("sourceCode", this.sourceCode);
        }

        const { status } = await ProgramService.postPentest(formData);
        if (status === 201) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("swalSendPentest"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });

          this.$router.push("pentest/list");
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style>
.avatar-wrapper {
  height: 85px;
  width: 85px;
}

.editor-toolbar {
  border: 0px !important;
}

body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown),
html.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) {
  height: 100% !important;
  overflow-y: visible !important;
}
</style>
